/* eslint-disable @typescript-eslint/no-var-requires */
export const SearchPropertiesByDestinationForBrands = require('./lib/SearchPropertiesByDestinationForBrands.graphql');
export const phoenixShopSearchPropertiesByLocationInput = require('./lib/phoenixShopSearchPropertiesByLocationInput.graphql');
